<template>
  <div class="w-full flex flex-col items-center">
    <div class="pt-24">
      <InitialStateSVG />
    </div>
    <div class="pt-8 text-center main--content pb-32">
      <p class="text-zt-primary-200 text-zt-base leading-tight">
        {{ $t("message.inicioComponent.resultSearch") }}
      </p>
      <p class="pt-2 text-zt-md text-zt-dark-300">
        {{ $t("message.inicioComponent.infoSearch") }}
      </p>
    </div>
  </div>
</template>

<script>
import InitialStateSVG from './SVG/InitialSearch'

export default {
  name: 'SearchInitialState',
  components: {
    InitialStateSVG
  }
}
</script>

<style scoped>
.main--content {
  max-width: 450px;
}
</style>
